
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useContext, useRef, useState } from "react";
import Webcam from "react-webcam";
import { fixBase64Mime, helper } from "./utils/helper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { AppDB } from "../App";
import { Image } from "primereact/image";
import ScreenLoader from "./ScreenLoader";
import { PrimeIcons } from "primereact/api";
import { PrintOut } from "../pages/reports/PrintOut";
import GenericDocumentTableBuilder from "./GenericDocumentTableBuilder";

export default function ({ onDocumentChange = () => { return [] }, dontClearDocuments = false, refresh = false, setRefresh = () => { }, requestCall = () => { }, param = {}, show = false, extraAttributes = {}, setShow = () => { }, documentTypesLookUp = [], setDocuments = () => { }, documents = [] }) {
    const videoConstraints = {
        width: 1280,
        height: 720,
        facingMode: "user"
    };

    var fileRef = useRef()
    const webcamRef = useRef(null);
    var { toast } = useContext(AppDB)
    var [loading, setLoading] = useState(false)
    var [showPdf, setShowPdf] = useState(false)
    var [pdf, setPdf] = useState(null)
    var [cameraProp, setCameraProp] = useState({
        dropdown: [
            { key: "Upload", value: "upload" },
            { key: "Camera", value: "camera" }
        ],
        modes: [
            { key: "Back", value: "environment" },
            { key: "Front", value: "user" }
        ],
        selected: null,
        show_captureDialog: false,
        selectedDocumentType: null,
        mode: "user"
    })

    const imageFormats = [
        "jpeg",
        "jpg",
        "png",
        "gif",
        "bmp",
        "tiff",
        "tif",
        "webp",
        "svg",
        "ico",
        "apng"
    ];



    async function onChangeFile(file) {
        setLoading(true);

        var base64 = await helper.convertFileToBase64(file)
        var ext = `${file?.name?.split(".")?.pop() || ".bin"}`.toLowerCase()
        var _jump = {}
        if (imageFormats.includes(ext)) {
            _jump = { jump: base64 };
        }
        documents.push({
            ...extraAttributes,
            "title": file.name,
            "fileExtension": ext,
            "contentType": file.type,
            "binaryData": base64,
            "documentTypeID": cameraProp.selectedDocumentType,
            "description": "",
            "binaryType": documentTypesLookUp.find(e => e.id === cameraProp.selectedDocumentType).name,
            ..._jump
        })

        setDocuments([...documents])
        cameraProp.selected = null
        setCameraProp({ ...cameraProp })
        setLoading(false);
        try {
            onDocumentChange(documents)
        } catch (error) {

        }
    }

    function onCapture() {
        if (webcamRef?.current?.getScreenshot) {
            const imageSrc = webcamRef.current.getScreenshot();
            documents.push({
                ...extraAttributes,
                capture: true,
                "title": "Captured from camera",
                "fileExtension": '.jpeg',
                "contentType": 'image/jpeg',
                "binaryData": imageSrc,
                jump: imageSrc,
                "documentTypeID": cameraProp.selectedDocumentType,
                "description": "",
                "binaryType": documentTypesLookUp.find(e => e.id === cameraProp.selectedDocumentType).name
            })
            setDocuments([...documents])
            cameraProp.selected = null
            setCameraProp({ ...cameraProp })
        } else {
            return toast.show({
                severity: "error",
                detail: 'Camera not active',
                life: 2500
            });
        }
    }


    function submitForm() {
        var clone = [...documents];
        clone = clone.map(e => {
            var res = e?.binaryData?.split(",");
            if (res?.length > 1) {
                e.binaryData = res[1];
            }
            e = { ...e, ...extraAttributes }
            return e;
        })


        try {
            setLoading(true)
            requestCall(clone, param).then(res => {
                setLoading(false)
                if (res.success) {
                    setRefresh(!refresh)
                    toast.show({
                        severity: "success",
                        detail: "Files Uploaded",
                        life: 2500
                    });
                    setDocuments([])
                    setShow(false)
                } else {

                    toast.show({
                        severity: "error",
                        detail: res.message,
                        life: 2500
                    })
                }
            })
        } catch (error) {
            setLoading(false)
        }
    }


    function renderDocument(row) {
        if (row?.jump?.length > 3) {
            return row?.jump
        }
        if (!row.binaryData.includes("data")) {
            return `data:image/png;base64,${row.binaryData}`
        }
        if (!row.binaryData.startsWith("data:image/")) {
            return row.binaryData
        }
        return fixBase64Mime(row.binaryData)

    }

    return (<>
        <ScreenLoader visible={loading} />
        {pdf !== null && <PrintOut isReport={false} base64={pdf} setBase64={setPdf} showDialog={showPdf} setShowDialog={setShowPdf} />
        }

        <Dialog
            visible={show}
            onHide={(e) => {
                if (dontClearDocuments) {
                    return setShow(false)
                }
                confirmPopup({
                    target: e?.currentTarget,
                    message: 'Are you sure you want to proceed?',
                    icon: 'pi pi-exclamation-triangle',
                    defaultFocus: 'accept',
                    accept: () => {

                        setDocuments([])
                        setShow(false)
                    },
                    reject: () => { }
                });
            }}
            header={"Documents"}

            style={{ width: "100%", maxWidth: "800px" }}
            footer={<>

                {dontClearDocuments === false && (documents?.length > 0 && (<>
                    <Button loading={loading} label="Submit" onClick={submitForm} />
                </>))}
                <Button label="Close" className="p-button-danger  ml-2" onClick={(e) => {
                    if (dontClearDocuments) {
                        return setShow(false)
                    }
                    confirmPopup({
                        target: e.currentTarget,
                        message: 'Are you sure you want to proceed?',
                        icon: 'pi pi-exclamation-triangle',
                        defaultFocus: 'accept',
                        accept: () => {
                            setDocuments([])
                            setShow(false)
                        },
                        reject: () => { }
                    });
                }} />


            </>}
        >
            <div className="grid">

                <div className="col-12">
                    <label className="w-full">Document Type</label>
                    <br />
                    <Dropdown className="w-full" onChange={e => {
                        cameraProp.selectedDocumentType = e.value;

                        setCameraProp({ ...cameraProp })
                    }} options={documentTypesLookUp} value={cameraProp.selectedDocumentType} optionLabel="name" optionValue="id" />
                </div>




                {cameraProp.selectedDocumentType !== null && (<>
                    <div className="col-12">
                        <label className="w-full">Select Option</label>
                        <br />
                        <Dropdown className="w-full" onChange={e => {
                            cameraProp.selected = e.value;
                            setCameraProp({ ...cameraProp })
                        }} options={cameraProp.dropdown} value={cameraProp.selected} optionLabel="key" optionValue="value" />
                    </div>
                </>)}
            </div>

            <ConfirmPopup />

            <GenericDocumentTableBuilder header={""} setDocuments={setDocuments} documents={documents} showAction={true} />


            <DataTable style={{ display: "none" }} value={documents}>
                <Column field="title" header={"Title"} />
                <Column field="description" header={"Description"} />
                <Column field="preview" header={"Preview"}
                    body={row => (<>

                        {/* {helper.checkBase64Type(row.binaryData) === "img" && (<Image preview width="50px" src={row.binaryData} />)} */}
                        {(row?.jump?.length > 3 || helper.checkBase64Type(row.binaryData) === "img" || imageFormats.includes(row?.ext)) && (
                            <Image preview width="50px" src={renderDocument(row)} />
                        )}
                        {helper.checkBase64Type(row.binaryData) === "pdf" && (<span
                            onClick={e => {
                                setPdf(row.binaryData)
                                setShowPdf(true)
                            }}
                            width="100px" style={{ width: "100px", objectFit: "cover" }}>
                            <i className={PrimeIcons.FILE_PDF} style={{ fontSize: "16px", color: "red" }}></i>{" "}
                            {"PDF"}
                        </span>)}

                    </>)}
                />
                <Column header={"Action"} field="Action" body={(row, data) => <Button
                    style={{
                        textAlign: "center",
                        width: "30px",
                        height: "30px",
                    }}
                    icon={"pi pi-trash"}
                    className="p-button-danger p-button-rounded"
                    onClick={(e) => {
                        confirmPopup({
                            target: e.currentTarget,
                            message: 'Are you sure you want to proceed?',
                            icon: 'pi pi-exclamation-triangle',
                            defaultFocus: 'accept',
                            accept: () => {
                                var doc = documents.filter((_, index) => index !== data.rowIndex)
                                setDocuments(doc)
                            },
                            reject: () => { }
                        });

                    }}
                />}></Column>
            </DataTable>
        </Dialog>

        <Dialog
            header={cameraProp.selected === "camera" ? "Capture" : "Upload"}
            key={cameraProp.selected}
            style={{ width: "100%", maxWidth: cameraProp.selected === "camera" ? "400px" : "300px" }}
            visible={cameraProp.selected !== null}
            onHide={() => {
                cameraProp.selected = null
                setCameraProp({ ...cameraProp })
            }}
            footer={<>
                {cameraProp.selected === "camera" && (<>
                    <Button label="Capture" onClick={onCapture} />
                </>)}
                <Button label="Close" className="p-button-danger  ml-2" onClick={() => {
                    cameraProp.selected = null
                    setCameraProp({ ...cameraProp })
                }} />


            </>}
        >
            {cameraProp.selected === "camera" && (<>
                <div className="col-12">
                    <label className="w-full">Camera Mode</label>
                    <br />
                    <Dropdown className="w-full" onChange={e => {
                        cameraProp.mode = e.value;
                        setCameraProp({ ...cameraProp })
                    }} options={cameraProp.modes} value={cameraProp.mode} optionLabel="key" optionValue="value" />
                </div>

            </>)}
            {cameraProp.selected === "camera" && (<>
                <Webcam
                    audio={false}
                    height={350}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    width={"100%"}
                    key={cameraProp.mode}
                    style={{ zoom: 0.6 }}
                    videoConstraints={{ videoConstraints, facingMode: cameraProp.mode }}
                />
            </>)}
            {cameraProp.selected === "upload" && (<>
                <div className="grid">
                    <div className="col-12">
                        <input onChange={e => onChangeFile(e.target.files[0])} type="file" ref={fileRef} style={{ display: "none" }} />
                        <Button icon="pi pi-plus" className="my-2" label="Upload" onClick={() => {
                            fileRef.current.value = "";
                            fileRef.current.click()
                        }} />
                    </div>
                </div>
            </>)}


        </Dialog>
    </>)
}